import { render } from "./LoadingPanel.vue?vue&type=template&id=3f9aec82"
const script = {}

import "./LoadingPanel.vue?vue&type=style&index=0&id=3f9aec82&lang=css"

import exportComponent from "/Users/suryaardiansah/Documents/Project/Programming/Vue/BACKUPP/vue-backup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__